import { combineSlices } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import localStorage from "redux-persist/lib/storage";
import sessionStorage from "redux-persist/lib/storage/session";

import { nextCargoApi } from "./apis/baseApi";
import { ipifyApi } from "./apis/ipify";
import { authSlice } from "./slices";

const persistConfig = {
  key: "@root",
  storage: localStorage,
  version: 1,
  blacklist: [nextCargoApi.reducerPath, ipifyApi.reducerPath, authSlice.name]
};

const authPersistConfig = {
  key: "@auth",
  version: 1,
  storage: sessionStorage
};

export const rootReducer = combineSlices(nextCargoApi, ipifyApi, {
  [authSlice.name]: persistReducer(authPersistConfig, authSlice.reducer)
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);
